module.exports = __webpack_public_path__ + "static/img/zdh.5b66be19.gif";